export enum EnterEmailLocalizationId {
    LogIn = "sign-in-enter-email.log_in_title",
    Email = "sign-in-enter-email.email_label",
    ContinueButton = "sign-in-enter-email.continue_button",
    StepPicture = "sign-in-enter-email.step_picture",
    CredentialsLink = "sign-in-enter-email.credentials_link",
    LoginHelperText = "sign-in-enter-email.log_in_helper_text",
}
